import { Box } from './Box'
import { Container } from './Container'

export const Footer = {
  Container,
  Box,
}
